<template>
  <div class="payMent">
    <el-dialog :title="$t('data.description')" class="diglog-card" style="border-radius: 12px" :visible.sync="dialogVisible" width="580px" @close="isEdit=false">
      <div class="header-line" />
      <div class="section-title" />
      <el-form ref="form" class="mt-12 ml-12" :model="form" label-position="left">
        <div>
          <el-form-item
            v-if="$store.getters.curCountry.country_code === 'TH'"
            class="mt-12"
            :label="$t('merchantAccount.beneficiary_account_type') + ':'"
            prop="beneficiary_account_type"
          >
            {{ beneficiaryAccountTypeFormat(detailInfo.beneficiary_account_type) }}
          </el-form-item>
          <el-form-item
            v-if="$store.getters.curCountry.country_code === 'TH' && detailInfo.beneficiary_account_type === 'PROMPTPAY'"
            :label="$t('merchantAccount.beneficiary_type') + ':'"
            prop="beneficiary_type"
          >
            {{ beneficiaryTypeFormat(detailInfo.beneficiary_type) }}
          </el-form-item>
          <el-form-item
            v-if="$store.getters.curCountry.country_code !== 'TH' || detailInfo.beneficiary_account_type !== 'PROMPTPAY'"
            :label="$t('merchantAccount.receiving_channel')+ ':'"
            prop="merchant_type"
          >
            {{ detailInfo.disbursement_channel }}
          </el-form-item>
          <el-form-item
            :label="$t('merchantAccount.beneficiary_name') + ':'"
            prop="role_name"
          >
            {{ detailInfo.disbursement_name }}
          </el-form-item>
          <el-form-item
            :label="$t('merchantAccount.beneficiary_account_no') + ':'"
            prop="role_name"
          >
            {{ detailInfo.disbursement_number }}
          </el-form-item>
          <el-form-item
            :label="$t('merchantAccount.short_name') + ':'"
            prop="disbursement_short_name"
            required
          >
            <span v-if="!isEdit">{{ detailInfo.disbursement_short_name }}</span>
            <el-input v-else v-model="form.disbursement_short_name" style="width:200px" class="from-input" maxlength="15" size="small" clearable overflow: auto show-word-limit />

            <el-button v-if="!isEdit" class="ml-20 confirm-btn-bg" size="small" @click="onClickEditShort">{{ $t('components.edit') }}</el-button>
            <el-button v-if="isEdit" class="ml-20 confirm-btn-bg" size="small" @click="onClickSubmit">{{ $t('components.confirm') }}</el-button>
            <el-button v-if="isEdit" class="ml-20 cancel-btn-bg" size="small" @click="cancelShortName">{{ $t('components.cancel') }}</el-button>
          </el-form-item>
          <!--海湾六国收款人信息-->
          <template v-if="isGulfCountry">
            <el-form-item
              :label="$t('merchantAccount.beneficiary_iban') + ':'"
            >
              {{ detailInfo.iban }}
            </el-form-item>
            <el-form-item
              :label="$t('merchantAccount.beneficiary_swift_code') + ':'"
            >
              {{ detailInfo.swift_code }}
            </el-form-item>
            <el-form-item
              :label="$t('merchantAccount.beneficiary_bank_address') + ':'"
            >
              {{ detailInfo.bank_address }}
            </el-form-item>
            <el-form-item
              :label="$t('merchantAccount.beneficiary_en_first_name') + ':'"
            >
              {{ detailInfo.en_first_name }}
            </el-form-item>
            <el-form-item
              :label="$t('merchantAccount.beneficiary_en_last_name') + ':'"
            >
              {{ detailInfo.en_last_name }}
            </el-form-item>
            <el-form-item
              :label="$t('merchantAccount.beneficiary_native_first_name') + ':'"
            >
              {{ detailInfo.local_first_name }}
            </el-form-item>
            <el-form-item
              :label="$t('merchantAccount.beneficiary_native_last_name') + ':'"
            >
              {{ detailInfo.local_last_name }}
            </el-form-item>
          </template>
          <el-form-item
            v-if="$store.getters.curCountry.country_code === 'TH'"
            :label="$t('merchantAccount.beneficiary_mobile') + ':'"
            prop="beneficiary_mobile"
          >
            {{ detailInfo.beneficiary_mobile }}
          </el-form-item>
          <el-form-item
            v-if="detailInfo.expire_time && !showExpireTime"
            :label="$t('merchantAccount.expire_time') + ':'"
            prop="expire_time"
          >
            {{ formattedDate }}
          </el-form-item>
        </div>

        <div class="mt-12">
          <h2 class="font_size_title">{{ $t('merchantAccount.other') }}</h2>
          <el-form-item
            class="mt-8"
            :label="$t('data.remark') + ':'"
            prop="remark"
          >
            <div class="from-input" style="display: inline-block;word-break: break-word; white-space: pre-line;line-height: 1.5;margin-top: 7px;">
              {{ detailInfo.remark }}
            </div>
          </el-form-item>

          <el-form-item
            v-if="showReviewComments"
            :label="$t('merchantAccount.review_comments') + ':'"
            prop="review_comments"
          >
            <div class="from-input" style="display: inline-block;word-break: break-word; white-space: pre-line;line-height: 1.5;margin-top: 7px;">
              {{ detailInfo.audit_recommend }}
            </div>
          </el-form-item>
        </div>

        <div class="mt-12">
          <h2 class="font_size_title">{{ $t('merchantAccount.attachments') }}</h2>
          <el-form-item
            class="mt-8"
            :label="$t('customerService.attachments') + ':'"
          >

            <template v-if="detailInfo.contract_attachment_list">
              <div v-for="item in detailInfo.contract_attachment_list" :key="item.file_name">
                <img v-if="isImg(item.file_name)" v-viewer class="content-img reply-content-img" :src="item.file_oss_url" alt="">
                <div v-else class="reply-content-file" @click="onClickIcon(item.file_name,item.file_oss_url )">{{ item.file_name }}</div>
              </div>
            </template>
          </el-form-item>

        </div>
      </el-form>
      <!--      <div class="btn-container">-->
      <!--        <el-button @click="dialogVisible=false">{{ $t('components.close') }}</el-button>-->
      <!--        <el-button v-if="isEdit" type="primary" :disabled="submiting" @click="onClickSubmit">{{ $t('components.submit') }}</el-button>-->
      <!--      </div>-->
      <el-button type="info" class="btn-submit ml-12" @click="dialogVisible = false">Close</el-button>
    </el-dialog>
  </div>
</template>

<script>

import { queryLargeValueBeneficiaryDetail, updateBeneficiaryShortName } from '@/api/online-transaction/online-transaction.js'
import { GULF_USD_ONLY_COUNTRY_CODES } from '@/const/const.js'

export default {
  name: 'LargePayoutStepDetailModal',
  data() {
    return {
      dialogVisible: false,
      listLoading: false,
      detailInfo: {
        audit_recommend: ''
      },
      form: {
        amount: 0,
        disbursement_short_name: null
      },
      modalData: {},
      isEdit: false,
      submiting: false,
      showReviewComments: false,
      showExpireTime: true
    }
  },
  computed: {
    beneficiaryAccountTypeFormat() {
      const obj = {
        'BANK': this.$t('map.beneficiary_account_type_0'),
        'PROMPTPAY': this.$t('map.beneficiary_account_type_1')
      }
      return function(value) {
        if (value) {
          return obj[value]
        }
        return value
      }
    },
    beneficiaryTypeFormat() {
      const obj = {
        'NATIONAL_ID': this.$t('map.beneficiary_type_0'),
        'MOBILE_NUMBER': this.$t('map.beneficiary_type_1')
      }
      return function(value) {
        if (value) {
          return obj[value]
        }
        return value
      }
    },
    isImg() {
      return function(value) {
        return /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(value)
      }
    },
    formattedDate() {
      const date = new Date(this.detailInfo.expire_time || '')
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + date.getDate()).slice(-2)
      const time = `${year}-${month}-${day}`
      if (time === '2100-12-31') {
        return this.$t('merchantAccount.permanent')
      }
      return time
    },
    remarkDescTxt() {
      let desc = this.detailInfo.remark || ''
      desc = desc.replace(/(\r\n)/g, '<br/>')
      desc = desc.replace(/(\n)/g, '<br/>')
      return desc
    },
    auditRecommendDescTxt() {
      let desc = this.detailInfo.audit_recommend || ''
      desc = desc.replace(/(\r\n)/g, '<br/>')
      desc = desc.replace(/(\n)/g, '<br/>')
      return desc
    },
    isGulfCountry() {
      // 暂时只针对沙特
      return this.$store.getters.curCountry.country_code === 'SA'
      // return GULF_USD_ONLY_COUNTRY_CODES.includes(this.$store.getters.curCountry.country_code)
    }
  },
  mounted() {
  },
  methods: {
    showModal(row) {
      this.dialogVisible = true
      if (row) {
        this.getDetail(row)
      }
      this.modalData = row
      this.showReviewComments = row.status === 3 || row.status === 4
      this.showExpireTime = row.status === 3 || row.status === 4
      this.clearValidate()
    },
    clearValidate() {
      this.$nextTick(function() {
        this.$refs['form'].clearValidate()
      })
    },
    cancelShortName() {
      this.isEdit = false
      this.clearValidate()
    },
    getDetail(row) {
      queryLargeValueBeneficiaryDetail({ id: row.id }).then(res => {
        const { ...otherData } = res.data
        this.detailInfo = {
          ...otherData
        }
      })
    },
    onClickSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.submiting = true
          const params = {
            id: this.detailInfo.id,
            ...this.form
          }
          updateBeneficiaryShortName(params).then(res => {
            if (res.code === 10000) {
              this.isEdit = false
              this.getDetail(this.modalData)
              this.$message.success('Success')
              this.$emit('updateList')
            }
          }).finally(() => {
            this.dialogTableVisible = false
            this.submiting = false
          })
        }
      })
    },
    onClickEditShort() {
      this.isEdit = true
      this.form.disbursement_short_name = this.detailInfo.disbursement_short_name
    },
    onClickIcon(fileName, url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style>
.diglog-card .el-form-item__label{
  line-height: 36px;
}
.diglog-card .el-form-item {
  margin-bottom: 10px;
}
.diglog-card .el-dialog {
  border-radius: 12px;
}
.diglog-card .el-dialog__body {
  padding-top: 20px;
}
.diglog-card .el-dialog__title {
  padding-left: 24px;
  color: #3855F1;
}
</style>

<style scoped lang="scss">
.btn-container{
  margin-top: 32px;
  text-align: right;
}
.total{
  display: inline-flex;
  justify-content: space-between;
  margin-top: 18px;
  min-width: 300px;

  .line{
    display: inline-block;
    content:'';
    height: 52px;
    width: 1px;
    background: #D3D7DF;
  }
  &-title{
    font-size: 14px;
    line-height: 17px;
    color: #606266;
  }
  &-num{
    margin-top: 12px;
    font-size: 22px;
    font-family: Source Han Sans SC;
    font-weight: 600;  font-family: 'Inter-SemiBold';
    line-height: 1.2;
    color: #3855F1;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 17px;
  color: #1D3A71;
}
.content-gray{
  flex: 1;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 15px;
  color: #4B5567;
}

.large-payout-detail-modal{
  .payin-status{
    text-align: center;
    position: absolute;
    top: 20px;
    left: 210px;
  }
}

.content-img{
  cursor: pointer;
  height: 100px;
  max-width: 300px;
}
.content-file{
  color:#3855F1;
  text-decoration: underline;
  cursor: pointer;
}

.reply-content-img{
  margin-bottom: 10px;
}
.reply-content-file{
  margin-bottom: 10px;
  cursor: pointer;
  text-decoration: underline;
  color: #3855F1;
}
.mt-12{
  margin-top: 24px;
}
.ml-12{
  margin-left: 24px;
}
.font_size_title {
  font-size: 18px;
  color: #000000;
}
.mt-8{
  margin-top: 8px;
}
.btn-submit{
    padding: 12px;
    width: 500px;
    // height: 40px;
    font-weight: 700;
    font-size: 16px;
    margin-top: 29px;
    margin-bottom: 40px;
}
.ml-20 {
  margin-left: 20px;
}
.confirm-btn-bg {
  color: #FFFFFF;
  background-color: #3855F1;
}
.cancel-btn-bg {
  color: #FFFFFF;
  background-color: #98a1b4;
}
.payMent{
  .payin-status{
    text-align: center;
    position: absolute;
    top: 20px;
    left: 210px;
  }
}
</style>

